import { Injectable } from '@angular/core';
import { SpxStorage, SpxStorageKeyEnum } from '@softpak/components/spx-storage';

import { StatsUpdateLogQueryI } from 'src/app/api/stats-update-log/stats-update-log.query.int';

type StatsUpdateLogQueryExtrasI = {
    channelType?: string;
    customer?: string;
    details?: unknown;
    error?: string;
    updateCheckType?: string;
};

@Injectable({
    providedIn: 'root',
})
export class StatsUpdateLogQueryService {
    createUpdateLogQuery(
        step: string,
        status: string,
        extras?: StatsUpdateLogQueryExtrasI,
    ): StatsUpdateLogQueryI {
        return {
            app: 'orders',
            bundleVersion: this.getStorageValue(SpxStorageKeyEnum.bundleVersion),
            channelType: extras?.channelType ?? this.getStorageValue(SpxStorageKeyEnum.channelType),
            customer: extras?.customer ?? this.getStorageValue(SpxStorageKeyEnum.brand),
            details: this.stringify(extras?.details),
            error: this.stringify(extras?.error),
            eventAt: new Date().toISOString(),
            liveUpdate: this.getStorageValue(SpxStorageKeyEnum.liveUpdate),
            liveUpdateChannel: this.getStorageValue(SpxStorageKeyEnum.liveUpdateChannel),
            platform: this.getStorageValue(SpxStorageKeyEnum.platform),
            platformVersion: this.getStorageValue(SpxStorageKeyEnum.platformVersion),
            randomDeviceId: this.getStorageValue(SpxStorageKeyEnum.randomDeviceId),
            updateCheckType: extras?.updateCheckType ?? 'BACKGROUND',
            steps: '',
            status,
            step,
            username: this.getStorageValue(SpxStorageKeyEnum.username),
        };
    }

    private getStorageValue(key: SpxStorageKeyEnum): string {
        const value = SpxStorage.getSetting(key);
        return value == null ? '' : String(value);
    }

    private stringify(value: unknown): string {
        if (value == null) return '';
        if (typeof value === 'string') return value;
        try {
            return JSON.stringify(value);
        } catch {
            return String(value);
        }
    }
}
